import { useState } from 'react';
import { useUserContext } from '@/auth/UserContext';
import { useJoinVideoMeeting } from '@/pages/Mail/hooks/useJoinVideoMeeting';
import { toVideoMeetings } from '@/pages/Mail/videoMeetings';
import { VideoMeetingGroup } from '@/types/components';
import { PARENT_ROLES } from '@/types/user';
import type { VideoMeetingResponse } from '@/types/video';

export const useLessonVideoMeeting = (response: VideoMeetingResponse) => {
  const { user } = useUserContext();
  const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = useState(false);

  const [meeting] = toVideoMeetings([response]);
  const isParent = !!user?.personType && PARENT_ROLES.has(user.personType);
  const isToday = meeting.group === VideoMeetingGroup.Today;
  const isJoinVisible = meeting.isActive && isToday && !isParent;

  const joinMeeting = useJoinVideoMeeting({
    meetings: [meeting],
    onError: () => setIsErrorSnackbarOpen(true),
  });

  return {
    meeting,
    isJoinVisible,
    isErrorSnackbarOpen,
    join: () => joinMeeting(meeting.id),
    closeErrorSnackbar: () => setIsErrorSnackbarOpen(false),
  };
};
